export default __webpack_public_path__ + "static/media/3.eebb9930.png";